module.exports = "https://www.gc-qa.gnp.com.mx/4ff61bc6efa5864e45a1d69ef607e19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/acceso-compartido/02.png
// module id = 996
// module chunks = 0 1